<div class="dialog-header" cdkDrag cdkDragRootElement=".cdk-overlay-pane">
  <div class="header-side"></div>
  <div class="dialog-title-text" cdkDragHandle>
    {{ 'Edit Salisbury Dosing (' + dialogData.id + ')' }}
  </div>
  <button mat-icon-button class="close-btn" (click)="onClose()">
    <mat-icon>close</mat-icon>
  </button>
</div>
<mat-dialog-content>
  <form [formGroup]="sdForm" (ngSubmit)="onSave()" class="form-grid">
    <!-- First Row -->
    <div class="form-grid-row">
      <mat-form-field appearance="outline">
        <mat-label>Tank </mat-label>
        <input matInput formControlName="tank" data-testid="tank" [disabled]="true" readonly>
      </mat-form-field>
    </div>
    <div class="form-grid-row">
      <app-datetime-picker-input label="Date Captured" formControlName="dtc" name="dtc" required [use24Hour]="false">
      </app-datetime-picker-input>
    </div>
    <!-- Second Row -->
    <div class="form-grid-row">
      <mat-form-field appearance="outline">
        <mat-label>Loads </mat-label>
        <input matInput formControlName="loads" data-testid="loads" (input)="roundOff($event, 999999, 4, 'loads')">
        @if (sdForm.get('loads')?.invalid && sdForm.get('loads')?.touched) {
        <mat-error>Loads is required</mat-error>
        }
      </mat-form-field>
    </div>
    <div class="form-grid-row">
      <mat-form-field appearance="outline">
        <mat-label>Other</mat-label>
        <input matInput type="text" data-testid="other" formControlName="other"
          (input)="roundOff($event, 999999, 4, 'other')">
        @if (sdForm.get('other')?.invalid && sdForm.get('other')?.touched) {
        <mat-error>Other is required</mat-error>
        }
      </mat-form-field>
    </div>
  </form>
</mat-dialog-content>
<mat-dialog-actions align="end" class="dialog-footer">
  <button mat-raised-button color="primary" mat-primary data-testid="btnClose" (click)="onClose()">Cancel</button>
  <button mat-raised-button color="primary" mat-primary data-testid="btnSave" (click)="onSave()">Save</button>
</mat-dialog-actions>